import { StyledCard } from '@app/components/card/Card';
import { Flex, Statistic } from 'antd';

const TotalsCard = ({ totals }: { totals: Record<string, string> }) => {
    return (
        <StyledCard className="totals-card">
            <Flex vertical={true} gap={20}>
                <h2>Total</h2>
                {Object.keys(totals).length ? (
                    <div className="totals-list">
                        {Object.entries(totals).map(([key, value]) => (
                            <Statistic key={key} title={key} value={value} />
                        ))}
                    </div>
                ) : (
                    <Statistic value={'0.00'} />
                )}
            </Flex>
        </StyledCard>
    );
};

export default TotalsCard;
